import { useState } from "react";
import { useTranslate } from "@refinedev/core";

export function useAgreementAppForm() {
  const [activeStep, setActiveStep] = useState(0);
  const translate = useTranslate();

  const steps = [
    translate("v1/agreement_app_admin.steps.1"),
    translate("v1/agreement_app_admin.steps.2"),
  ];

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const handleSubmit = (onSubmit: () => void) => {
    onSubmit();
  };

  return {
    steps,
    activeStep,
    handleStep,
    handleNext,
    handleBack,
    handleSubmit,
    isLastStep: activeStep === steps.length - 1,
  };
}
